module.exports = __webpack_public_path__ + "img/cloud-rain.ffcc0fba.svg";